













import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetDlyRecords, GetPatDlyComplications} from "@/api/hd"
import {GetListByCode} from "@/api/configureDictionary"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	data: any = []
	loading = false
	columns = [
		{
			title: '时间',
			key: 'recordTime'
		}, {
			title: '并发症类型',
			key: 'declare'
		}, {
			title: '操作人',
			key: 'createUser'
		}, {
			title: '原因及处理措施',
			render: (h: any, params: any) => {
				let arr:any = []
				if (params.row.items.length) {
					params.row.items.forEach((item:any) => {
						arr.push(h('div'),'原因：' + item.reasonDeclare + '措施：' + item.handleDeclare)
					})
				}
				return h('div', arr)
			}
		},
	]

	created() {
		this.init()
	}

	private async init() {
		this.loading = true
		let query: any = {
			PatientId: this.patient.id
		}
		let res = await GetPatDlyComplications(query)
		this.data = res.objects
		this.loading = false
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisInfo/complication/index.vue